import React, { Component } from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom'
import { getFreeeAccessToken, getGoogleAccessToken, getGoogleRefreshToken, getFreeeRefreshToken, clearToken } from '../utils/AuthService'
import {consoleLog} from "../utils/log";
import { validateEmail } from "../utils/EmailChecker";

const baseUrl = process.env.REACT_APP_FREEE_BASE_URL
const companyRecordGetUrl = process.env.REACT_APP_COMPANY_RECORD_GET_URL
const apiUrl = process.env.REACT_APP_AWS_API_BASE_URL
const apiKey = process.env.REACT_APP_AWS_API_KEY

class Register extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      companies: {
      },
      isFetched: false,
      isPosting: false,
      isRegisterd: false,
      isManualExcuting: false,
      registeredCompanies: {
        id: "",
        account_create_date: "",
        account_suspend_date: "",
        email: "",
      },
      isError: false,
      registerDate: null,
      autoExecuteTime: '',
      payload: {
        companyId: '',
        accountCreateDate: "1",
        accountSuspendDate: "1",
        email: '',
        freeeRefreshToken: '',
        googleRefreshToken: '',
      },
      emailConfirm: '',
      message: {
        companySelect: '',
        email: '',
        emailConfirm: '',
        requestResult: ''
      },
    };
    this.createSelectDateForm = this.createSelectDateForm.bind(this)
    this.getRegisterdCompany = this.getRegisterdCompany.bind(this)
    this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this)
    this.handleManualRegisterExecButtonClick = this.handleManualRegisterExecButtonClick.bind(this)
    this.handleApiRequest = this.handleApiRequest.bind(this)
    this.isValidPayload = this.isValidPayload.bind(this)
    this.createInitialState = this.createInitialState.bind(this)
    this.removeNonAdminCompany = this.removeNonAdminCompany.bind(this)
    this.createInitialState()
  }

  createInitialState() {
    const accessToken = getFreeeAccessToken();
    consoleLog(`freeeAccessToken: ${accessToken}`)
    const requestUrl = `${baseUrl}/api/v1/users/me`
    axios({
      method: 'GET',
      url: requestUrl,
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    }).then(result => {
      let newState = Object.assign({}, this.state);
      newState.id = result.data.id
      newState.companies = this.removeNonAdminCompany(result.data.companies)
      newState.payload.companyId = newState.companies[0].id
      newState.payload.freeeRefreshToken = getFreeeRefreshToken()
      newState.payload.googleRefreshToken = getGoogleRefreshToken()
      let registerdCompanies = []
      result.data.companies.map(company => {
        axios({
          method: 'GET',
          url: companyRecordGetUrl + '/api/company',
          headers: {
            'x-api-key': apiKey
          },
          params: {
            id: company.id
          },
        }).then(result => {
          if (result.data) {
            registerdCompanies.push(result.data)
          }
        }).then(() => {
          if (registerdCompanies.length != 0) {
            newState.registeredCompanies = registerdCompanies
            newState.payload.companyId = registerdCompanies[0].id
            newState.payload.accountCreateDate = registerdCompanies[0].account_create_date
            newState.payload.accountSuspendDate = registerdCompanies[0].account_suspend_date
            newState.payload.email = registerdCompanies[0].notification_email
            newState.isFetched = true
            newState.isRegisterd = true
            this.setState(newState)
          }
        })
      })
      newState.registeredCompanies = registerdCompanies
      newState.isFetched = true
      this.setState(newState)

    }).catch(err => {
      if (err) {
        clearToken()
        return (
          <div>
            <Redirect to="/Login" />
          </div>
        )
      }
    })
  }

  createSelectDateForm(type) {
    const registerDateList = []
    for (let i = 1; i < 31; i++) {
      let registerDate
      if (type === 'register') {
        registerDate = { key: i, label: `入社${i}日前` }
        registerDateList.push(registerDate)
      } else {
        registerDate = { key: i, label: `退社${i}日後` }
        registerDateList.push(registerDate)
      }
    }
    return registerDateList
  }

  isValidPayload(payload) {
    let newState = Object.assign({}, this.state);
    if (!payload.companyId) {
      newState.message.companySelect = "選択できる事業所がありません"
      this.setState(newState)
      return false
    }
    if (!payload.email) {
      newState.message.email = "メールアドレスを入力してください"
      this.setState(newState)
      return false
    }
    if (!validateEmail(payload.email)) {
      newState.message.email = "正しい形式のメールアドレスを入力してください"
      this.setState(newState)
      return false
    }
    if (payload.email !== this.state.emailConfirm) {
      newState.message.emailConfirm = "メールアドレスが一致しません"
      this.setState(newState)
      return false
    }
    this.setState({
      message: {
        email: null,
        emailConfirm: null
      }
    })
    return true
  }

  removeNonAdminCompany(companies) {
    const adminCompanies = companies.filter(company => company.role == 'company_admin')
    return adminCompanies
  }

  getRegisterdCompany(id) {
    const regsiterdCompany = this.state.registeredCompanies && this.state.registeredCompanies.filter(company =>
      company.id === id
    )
    return regsiterdCompany
  }

  handleApiRequest(requestUrl, method) {
    axios({
      method: method,
      url: requestUrl,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey
      },
      data: this.state.payload
    }).then(result => {
      if (method == 'POST') {
        let newState = Object.assign({}, this.state);
        const message = "自動実行登録が成功しました"
        let newRegisteredCompanies = Object.assign({}, this.state.registeredCompanies);
        newRegisteredCompanies.id = this.state.payload.companyId.toString()
        newRegisteredCompanies.account_create_date = this.state.payload.accountCreateDate
        newRegisteredCompanies.account_suspend_date = this.state.payload.accountSuspendDate
        newRegisteredCompanies.notification_email = this.state.payload.email
        newState.registeredCompanies.push(newRegisteredCompanies)
        newState.message.requestResult = message
        newState.isPosting = false
        newState.isRegisterd = true
        this.setState(newState);
      } else {
        let newState = Object.assign({}, this.state);
        const message = "自動実行登録解除が成功しました"
        let registeredCompanies = Object.assign([], this.state.registeredCompanies);
        registeredCompanies = registeredCompanies.filter(company =>
          company.id != this.state.payload.companyId
        )
        newState.registeredCompanies = registeredCompanies
        newState.message.requestResult = message
        newState.isPosting = false
        newState.isRegisterd = false
        this.setState(newState);
      }
    }).catch(err => {
      let newState = Object.assign({}, this.state);
      if (method == 'POST') {
        newState.message.requestResult = "自動実行登録が失敗しました。しばらく経ってから再度お試しください"
      } else {
        newState.message.requestResult = "自動実行登録解除が失敗しました。しばらく経ってから再度お試しください"
      }
      newState.isPosting = false
      this.setState(newState);
    })
  }

  handleCompanyChange = (e) => {
    let newState = Object.assign({}, this.state)
    const registerdCompany = this.getRegisterdCompany(e.target.value)
    if (registerdCompany.length != 0) {
      newState.payload.companyId = e.target.value
      newState.payload.accountCreateDate = registerdCompany[0].account_create_date
      newState.payload.accountSuspendDate = registerdCompany[0].account_suspend_date
      newState.payload.email = registerdCompany[0].notification_email
      newState.isRegisterd = true
      this.setState(newState);
    } else {
      newState.payload.companyId = e.target.value
      newState.isRegisterd = false
      newState.message.requestResult = ''
      this.setState(newState);
    }
  }
  handleCreateDateChange = (e) => {
    let newState = Object.assign({}, this.state);
    newState.payload.accountCreateDate = e.target.value;
    this.setState(newState)
  }
  handleSuspendDateChange = (e) => {
    let newState = Object.assign({}, this.state);
    newState.payload.accountSuspendDate = e.target.value;
    this.setState(newState)
  }
  handleEmailChange = (e) => {
    let newState = Object.assign({}, this.state);
    newState.payload.email = e.target.value;
    this.setState(newState);
  }
  handleEmailConfirmChange = (e) => {
    let newState = Object.assign({}, this.state);
    newState.emailConfirm = e.target.value;
    this.setState(newState);
  }

  handleRegisterButtonClick() {
    if (this.state.isPosting) {
      return false
    } else {
      this.setState({
        isPosting: true
      })
    }
    if (!this.isValidPayload(this.state.payload)) {
      this.setState({
        isPosting: false
      })
      return false
    }
    const requestUrl = `${apiUrl}/api/company`
    this.handleApiRequest(requestUrl, 'POST')
  }

  handleDeleteButtonClick(e) {
    const requestUrl = `${apiUrl}/api/company`
    if (this.state.isPosting) {
      return false
    } else {
      this.setState({
        isPosting: true
      })
    }
    this.handleApiRequest(requestUrl, 'DELETE')
  }

  handleManualRegisterExecButtonClick(e) {
    const requestUrl = `${apiUrl}/api/manual/register`
    if (this.state.isManualExcuting) {
      return false
    } else {
      this.setState({
        isManualExcuting: true
      })
    }
    if (!this.isValidPayload(this.state.payload)) {
      this.setState({
        isManualExcuting: false
      })
      return false
    }
    let payload = Object.assign({}, this.state.payload);
    payload.freeeAccessToken = getFreeeAccessToken()
    payload.googleAccessToken = getGoogleAccessToken()
    axios({
      method: 'POST',
      url: requestUrl,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey
      },
      data: payload
    }).then(result => {
      const message = "今すぐ実行が成功しました"
      this.setState({
        message: {
          requestResult: message,
        },
        isPosting: false,
        isManualExcuting: false
      });
    }).catch(err => {
      const message = "今すぐ実行が失敗しました。しばらく経ってから、再度お試しください"
      this.setState({
        message: {
          requestResult: message,
        },
        isManualExcuting: false,
        isError: true
      });
    })
  }

  render() {
    consoleLog(`googleAccessToken: ${getGoogleAccessToken()}`)
    const { companies, isFetched, isRegisterd, message, isError, isPosting, isManualExcuting } = this.state
    let possibleRegisterDate
    let possibleSuspendDate
    if (isFetched) {
      possibleRegisterDate = this.createSelectDateForm('register')
      possibleSuspendDate = this.createSelectDateForm('delete')
    }

    const companySelect = isFetched && companies.map(company => {
      const registerdCompany = this.state.registeredCompanies.filter(registeredCompany =>
        registeredCompany.id === company.id.toString()
      )
      if (registerdCompany.length != 0) {
        return (
          <option key={company.id} value={company.id}>
            登録済み {company.name}
          </option>
        )
      }
      return (
        <option key={company.id} value={company.id}>
          {company.name}
        </option>
      )
    })

    const createDateSelect = possibleRegisterDate && possibleRegisterDate.map(registerDate => (
      <option key={registerDate.key} value={registerDate.key}>
        {registerDate.label}
      </option>
    ))

    const suspendDateSelect = possibleSuspendDate && possibleSuspendDate.map(suspendDate => (
      <option key={suspendDate.key} value={suspendDate.key}>
        {suspendDate.label}
      </option>
    ))

    const renderMessage = message && isError ?
      <span vb-message vb-message--error vb-margin-right>
        {message.requestResult}
      </span>
      :
      <span vb-message vb-message--success vb-margin-right>
        {message.requestResult}
      </span>

    const renderCompanySelect = message.companySelect ?
      <div className="vb-selectWrap vb-selectWrap--vb-margin-right vb-margin-bottom">
        <select className="vb-select vb-select--error"
          value={this.state.payload.companyId}
          onChange={this.handleCompanyChange}
        >
          {isFetched && companySelect}
        </select>
      </div> :
      <div className="vb-selectWrap vb-selectWrap--vb-margin-right vb-margin-bottom">
        <select className="vb-wrap vb-select"
          value={this.state.payload.companyId}
          onChange={this.handleCompanyChange}
        >
          {isFetched && companySelect}
        </select>
      </div>

    const renderEmail = message.email ?
      <input className="vb-textField vb-textField--error" type="text"
        value={this.state.payload.email}
        onChange={this.handleEmailChange}
      /> :
      <input className="vb-textField" type="text"
        value={this.state.payload.email}
        onChange={this.handleEmailChange}
      />

    const renderEmailConfirm = message.emailConfirm ?
      <input type="text" className="vb-textField vb-textField--error"
        value={this.state.emailConfirm}
        onChange={this.handleEmailConfirmChange}
      />
      :
      <input type="text" className="vb-textField"
        value={this.state.emailConfirm}
        onChange={this.handleEmailConfirmChange}
      />

    const renderManualRegisterButton = isManualExcuting ?
      <button className="vb-button vb-button--primary vb-button--small"
        disabled={isManualExcuting}
      >実行中...</button>
      :
      <button className="vb-button vb-button--primary vb-button--small"
        onClick={this.handleManualRegisterExecButtonClick}
      >今すぐ実行（設定は保存されません）</button>

    let button
    isRegisterd ?
      button = <button className="vb-button vb-button--danger vb-button--small" onClick={() => this.handleDeleteButtonClick()}>自動実行登録を解除</button> :
      button = <button className="vb-button vb-button--primary vb-button--small" onClick={() => this.handleRegisterButtonClick()}>この設定で自動実行を登録</button>

    return (
      <div>
        <div className="header">
          <h2 className="text-center">G Suite連携アプリ</h2>
        </div>
        <div className="vb-contentsBase">
          <div className="form-section">
            <ul>
              <li>
                <label className="vb-title vb-title--section">事業所選択</label>
                {renderCompanySelect}
              </li>
              {message.companySelect}
              <li>
                <label className="vb-title vb-title--section">アカウント作成日時</label>
                <div className="vb-selectWrap vb-selectWrap--vb-margin-right vb-margin-bottom">
                  <select className="vb-wrap vb-select"
                    onChange={this.handleCreateDateChange}
                    value={this.state.payload.accountCreateDate}
                    defaultValue="1">
                    {isFetched && createDateSelect}
                  </select>
                </div>
              </li>
              <li>
                <label className="vb-title vb-title--section">アカウント停止日時</label>
                <div className="vb-selectWrap vb-selectWrap--vb-margin-right vb-margin-bottom">
                  <select className="vb-select"
                    value={this.state.payload.accountSuspendDate}
                    defaultValue="1"
                    onChange={this.handleSuspendDateChange}
                  >
                    {isFetched && suspendDateSelect}
                  </select>
                </div>
              </li>
              <li>
                <label className="vb-title vb-title--section">通知用メールアドレス</label>
                {renderEmail}
              </li>
              {message.email}
              <li>
                <label className="vb-title vb-title--section">通知用メールアドレス（確認用）</label>
                {renderEmailConfirm}
              </li>
              {message.emailConfirm}
            </ul>
          </div>
          <div className="button-section">
            <div className="row">
              <div className="vb-button--rapper">
                {button}
                {renderManualRegisterButton}
              </div>
            </div>
            {renderMessage}
          </div>
          <div>
          </div>
        </div>
      </div>
    )
  }
}

export default Register;